/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Marketplace_Seo_Spain_Faq_Q4Inputs */

const es_marketplace_seo_spain_faq_q4 = /** @type {(inputs: Marketplace_Seo_Spain_Faq_Q4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Qué tipos de barcos puedo alquilar?`)
};

const gl_marketplace_seo_spain_faq_q4 = /** @type {(inputs: Marketplace_Seo_Spain_Faq_Q4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Que tipos de barcos podo aluguer?`)
};

const en_marketplace_seo_spain_faq_q4 = /** @type {(inputs: Marketplace_Seo_Spain_Faq_Q4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What types of boats can I rent?`)
};

/**
* | output |
* | --- |
* | "What types of boats can I rent?" |
*
* @param {Marketplace_Seo_Spain_Faq_Q4Inputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const marketplace_seo_spain_faq_q4 = /** @type {((inputs?: Marketplace_Seo_Spain_Faq_Q4Inputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Marketplace_Seo_Spain_Faq_Q4Inputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_marketplace_seo_spain_faq_q4(inputs)
	if (locale === "en") return en_marketplace_seo_spain_faq_q4(inputs)
	return es_marketplace_seo_spain_faq_q4(inputs)
});